export default __webpack_public_path__ + "static/media/burgerboss.32dc70d7.svg";